module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8f5825c2f04d90933f0a23a9cac21487.png";